// Public entry point for the structural-extraction surface.
// Pure function — produces a `QueryStructure` from a `ParsedBuffer` + a
// statement reference. Covers `kind === 'select' | 'insert' | 'update' |
// 'delete' | 'merge'` per the SemanticResolverEdit PRD.
//
// PRD: Ralph/SemanticResolverEdit/PRD.md § Slices: Query Structure Extractor — SELECT / DML.

import type { StatementInfo } from '../../sql-grammar/model';
import type { ParsedBuffer, QueryStructure } from '../types';
import { extractSelectStructure } from './extractQueryStructure.select';
import { extractDmlStructure } from './extractQueryStructure.dml';

export function extractQueryStructure(
  buffer: ParsedBuffer,
  statementInfo: StatementInfo,
): QueryStructure {
  if (statementInfo.kind === 'select') {
    return extractSelectStructure(buffer, statementInfo);
  }
  if (
    statementInfo.kind === 'insert' || statementInfo.kind === 'update'
    || statementInfo.kind === 'delete' || statementInfo.kind === 'merge'
  ) {
    return extractDmlStructure(buffer, statementInfo);
  }
  // Anything else (DDL, CALL, transaction-control, …) is out of scope for
  // QueryStructure. Throw to make the misuse loud — VQE-Edit guards on kind
  // before calling, and silently returning a 'select' shell would mislead.
  throw new Error(`extractQueryStructure: statement kind '${statementInfo.kind}' is not a query shape`);
}
